import React, { ComponentType } from 'react';
import { CoursePricingOptionLocation } from '../../../../../../store/features/coursePricing';
import { ParagraphProps } from '../../styledComponents';

export type LocationProps = {
  showLocation: boolean;
  showVenue: boolean;
  location: CoursePricingOptionLocation;
  as: ComponentType<ParagraphProps>;
};

export const Location = (props: LocationProps) => {
  const { showLocation, showVenue, location, as: Component } = props;

  const { city, cityAsText, country, venueName } = location;

  const locationValue = showLocation
    ? [cityAsText || city, country].filter(Boolean)
    : [];
  const filteredValue = [...locationValue, showVenue && venueName]
    .filter(Boolean)
    .join(', ');

  if (!filteredValue) {
    return null;
  }

  return <Component text={filteredValue} />;
};
